import { Anchor, Box, Stack, Text } from "@mantine/core";

export interface ArticleAttachment {
  id: number;
  filename: string;
  description: string | null;
  url: string;
}

const IMAGE = /\.(png|jpg|jpeg|gif|webp|svg)$/i;

/** An FAQ article's attachments: images inline, other files as links. Used by
 *  the Office Guide's FAQ and by guide steps that show an FAQ article. */
export function ArticleAttachments({ attachments }: { attachments: ArticleAttachment[] }) {
  if (attachments.length === 0) return null;
  const images = attachments.filter((att) => IMAGE.test(att.filename));
  const files = attachments.filter((att) => !IMAGE.test(att.filename));
  return (
    <Stack gap="sm" mt="md" pt="md" style={{ borderTop: "1px solid var(--mantine-color-default-border)" }}>
      {images.length > 0 && (
        <Stack gap="xs">
          {images.map((att) => (
            <Anchor key={att.id} href={att.url} target="_blank" rel="noopener noreferrer">
              <img
                src={att.url}
                alt={att.description || att.filename}
                style={{ borderRadius: 6, maxWidth: "100%", maxHeight: 256, objectFit: "contain" }}
              />
            </Anchor>
          ))}
        </Stack>
      )}
      {files.length > 0 && (
        <Box>
          <Text fw={500} fz="sm" mb={4}>
            Attachments:
          </Text>
          <Stack gap={4}>
            {files.map((att) => (
              <Box key={att.id}>
                <Anchor href={att.url} target="_blank" rel="noopener noreferrer" fz="sm">
                  {att.filename}
                </Anchor>
              </Box>
            ))}
          </Stack>
        </Box>
      )}
    </Stack>
  );
}
